// extracted by mini-css-extract-plugin
export var button = "_c0-2";
export var iconWrapper = "_c0-0";
export var investigatingIcon = "_c0-1";